import { Navigate } from 'react-router-dom';

import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import AppLayout from './layouts/AppLayout';

import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import DashboardApp from './pages/DashboardApp';
import ClientPortfolioMain from './pages/ClientPortfolioMain';
import Employers from './pages/Employers';
import EmployerEdit from './pages/EmployerEdit';
import Client from './pages/Client';
import RegisterClient from './pages/RegisterClient';
import PharmCreateInvoice from './pages/PharmCreateInvoice';
import NotFound from './pages/Page404';
import UnderDev from './pages/UnderDev';
import ConfigApis from './pages/settings/ConfigApis';
import ConfigModules from './pages/settings/ConfigModules';
import ConfigNotifications from './pages/settings/ConfigNotifications';
import ConfigScheduler from './pages/settings/ConfigScheduler';
import ConfigTemplates from './pages/settings/ConfigTemplates';
import ConfigUsers from './pages/settings/ConfigUsers';
import ConfigEnterprise from './pages/settings/ConfigEnterprise';
import ClaimsSummaryProvider from './components/reports/claims/ClaimsSummaryProvider';
import ClaimsProvider from './components/reports/claims/ClaimsProvider';
import BatchSummary from './components/reports/claims/BatchSummary';
import FullMembership from './components/reports/claims/FullMembership';
import MembershipAgeGroup from './components/reports/claims/MembershipAgeGroup';
import MembershipAgeStats from './components/reports/claims/MembershipAgeStats';
import ClaimsDepartment from './components/reports/claims/ClaimsDepartment';
import RemittanceProvider from './components/reports/claims/RemittanceProvider';
import ClaimsDiagnosis from './components/reports/claims/ClaimsDiagnosis';
import MembershipChanges from './components/reports/claims/MembershipChanges';
import MembershipStats from './components/reports/claims/MembershipStats';
import ClaimsNonAwarded from './components/reports/claims/ClaimsNonAwarded';
import CreateBatches from './components/claims/CreateBatches';
import BatchMultipleDr from './components/claims/BatchMultipleDr';
import ClaimsSelect from './components/claims/ClaimsSelect';
import SelectBatch from './components/claims/SelectBatch';
import Claims from './components/claims/Claims';
import UpdateTariffs from './components/tariff/UpdateTariffs';
import Journal from './components/accounting/Journal';
import SelectVouchers from './components/accounting/SelectVouchers';
import ClaimsDeptDetail from './components/reports/claims/ClaimsDeptDetail';
import Remittance from './components/reports/claims/Remittance';
import ErrorCodes from './components/settings/ErrorCodes';
import ClaimsSelf from './components/claims/ClaimsSelf';
import RemittanceSelf from './components/reports/claims/RemittanceSelf';
import ProviderClaims from './components/reports/claimsnew/ProviderClaims';
import ProviderClaimsSummary from './components/reports/claimsnew/ProviderClaimsSummary';
import SelfPmtClaimsSummary from './components/reports/claimsnew/SelfPmtClaimsSummary';
import ProviderSummary from './components/reports/claimsnew/ProviderSummary';
import Provider from './pages/Provider';
import ClaimsSearch from './components/claims/ClaimsSearch';
import CycleMgmt from './components/settings/CycleMgmt';
import Providers from './components/settings/Providers';
import SelectSelfVouchers from './components/accounting/SelectSelfVouchers';
import JournalSelf from './components/accounting/JournalSelf';
import LimitsMgmt from './components/settings/LimitsMgmt';
import ClaimsByDeptSum from './components/reports/claimsnew/ClaimsByDeptSum';
import ClaimsByDeptDetail from './components/reports/claimsnew/ClaimsByDeptDetail';
import ProviderAccount from './components/accounting/ProviderAccount';
import ProviderBalances from './components/reports/claimsnew/ProviderBalances';
import Adjustment from './components/accounting/Adjustment';
import SelfPmtsBalances from './components/reports/claimsnew/SelfPmtsBalances';
import MembersByGroup from './components/reports/claimsnew/MembersByGroup';
import ProviderNonAwards from './components/reports/claimsnew/ProviderNonAwards';
import MembersByGroupDetail from './components/reports/claimsnew/MembersByGroupDetail';
import ExtraPayment from './components/accounting/ExtraPayment';
import ExtraReceipt from './components/accounting/ExtraReceipt';
import SelectBill from './components/subscriptions/SelectBill';
import Bill from './components/subscriptions/Bill';
import MemberBalances from './components/subscriptions/MemberBalances';
import ClaimsByDiagnosis from './components/reports/claimsnew/ClaimsByDiagnosis';
import ClaimsStatistics from './components/reports/claimsnew/ClaimsStatistics';
import ReceiptList from './components/reports/accounting/ReceiptList';
import SearchTariff from './components/settings/SearchTariff';
import ExtractSsb from './components/receipting/ExtractSsb';
import ReceiptFile from './components/receipting/ReceiptFile';
import SsbProcess from './components/ssb/SsbProcess';
import SelectSsb from './components/ssb/SelectSsb';
import ProcessFile from './components/receipting/ProcessFile';
import SelfRegister from './pages/SelfRegister';
import SelfRegSign from './components/authentication/selfregister/SelfRegSign';
import SelfRegSignature from './pages/SelfRegSignature';
import SelfRegRedirect from './pages/SelfRegRedirect';
import WebApplications from './components/clients/WebApplicaitons';
import UpdateSelfReg from './components/authentication/selfregister/UpdateSelfReg';
import MembershipProvince from './components/reports/membership/MembershipProvince';
import MembershipAge from './components/reports/membership/MembershipAge';
import MembershipRetire from './components/reports/membership/MembershipRetire';
import Defaults from './components/receipting/Defaults';
import PendingSubmission from './components/ssb/PendingSubmission';
import PrintStatement from './components/accounting/PrintStatement';
import TemplateList from './components/settings/TemplateList';
import TemplateSetup from './components/settings/TemplateSetup';
import MemberSummary from './pages/MemberSummary';
import RegisterInternal from './components/authentication/selfregister/RegisterInternal';
import TaskScheduler from './scheduler/Scheduler';
import ClaimsProcess from './components/claims/ClaimsProcess';
import PayBill from './components/accounting/PayBill';
import BillsList from './components/reports/accounting/BillsList';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RemoveData from './pages/RemoveData';
import SsbHistory from './components/receipting/SsbHistory';
import BulkBillDetails from './components/subscriptions/BulkBillDetails';
import SsbChangeFile from './components/receipting/SsbChangeFile';
import NewChangeFile from './components/ssb/NewChangeFile';
import ProcessChangeFile from './components/receipting/ProcessChangeFile';
import FilesInfoLookUp from './components/claims/FilesInfoLookUp';
import BenefitsLookUp from './components/claims/BenefitsLookUp';
import DisbursementFile from './components/reports/claimsnew/DisbursementFile';
import ProvinceSsbUpload from './components/ssb/ProvinceSsbUpload';
import SsbCodes from './components/settings/SsbCodes';
import ReceiptFileHist from './components/receipting/ReceiptFileHist';
import SsbHistFiles from './components/subscriptions/SsbHistFiles';
import ProcessHistFile from './components/receipting/ProcessHistFile';
import MembershipDistrict from './components/reports/membership/MembershipDistrict';
import MembershipsSummary from './components/reports/membership/MembershipSummary';
import DistrictBreakdown from './components/reports/membership/DistrictBreakdown';
import ActuarialReport from './components/reports/claimsnew/ActuarialReport';
import ClaimsImportList from './components/claims/ClaimsImportList';
import ClaimsImportNew from './components/claims/ClaimsImportNew';
import ClaimsImport from './components/claims/ClaimsImport';
import FileReports from './components/reports/membership/FileReports';
import DependantsEdit from './components/clients/DependantsEdit';
import DependantsAdd from './components/clients/DependantsAdd';
import DocumentsAdd from './components/clients/DocumentsAdd';
import DependantsQuick from './components/clients/DependantsQuick';
import DependantsHist from './components/dependants/DependantsHist';
import DependantsUploads from './components/dependants/DependantsUploads';
import ProcessDepUploads from './components/dependants/ProcessDepUploads';
import ProvinceFiles from './components/reports/membership/ProvinceFiles';
import ManageTemplates from './components/settings/ManageTemplates';
import CreateUser from './pages/settings/CreateUser';
import EditUser from './pages/settings/EditUser';
import ClaimStatuses from './components/settings/ClaimStatuses';
import BankList from './components/settings/BankList';
import ActiveWithoutSpouse from './components/reports/membership/ActiveWithoutSpouse';
import ActiveWithoutKids from './components/reports/membership/ActiveWithoutkids';
import ClaimsOnline from './components/claims/ClaimsOnline';
import OnlineClaimView from './components/claims/OnlineClaimView';
import OnlineProcessVet from './components/claimsonline/OnlineProcessVet';
import ManagementDash from './components/management/dashboard';
import DateRangeReport from './components/management/DateRangeReport';
import OnsOffsCharts from './components/provinces/charts/OnsOffsCharts';
import OnOffDash from './components/onoffs/OnOffDash';

// import DownloadFireFiles from './pages/DownloadFireFiles';

const Router = (isAuthenticated) => [
  {
    path: '/dashboard',
    // element: <DashboardLayout />,
    element: isAuthenticated ? <DashboardLayout /> : <Navigate to="/public/home" />,
    children: [
      { path: '/', element: <Navigate to="/dashboard/app" replace /> },
      { path: 'app', element: <DashboardApp /> },
      { path: 'client', element: <Client /> },
      { path: 'employers', element: <Employers /> },
      { path: 'editemployer', element: <EmployerEdit /> },
      { path: 'createinvoice', element: <PharmCreateInvoice /> },
      { path: 'providers', element: <Provider /> }
    ]
  },
  {
    path: '/clientportfolio',
    element: <DashboardLayout />,
    children: [
      { path: 'portfolio', element: <ClientPortfolioMain /> },
      { path: 'portfolios', element: <MemberSummary /> },
      { path: 'registerclient/:id', element: <RegisterClient /> },
      { path: 'webapplications', element: <WebApplications /> },
      { path: 'editdependant/:id', element: <DependantsEdit /> },
      { path: 'adddependant', element: <DependantsAdd /> },
      { path: 'adddocument', element: <DocumentsAdd /> },
      { path: 'dependantshist', element: <DependantsHist /> },
      { path: 'dependantsupload', element: <DependantsUploads /> },
      { path: 'depuploads/:id', element: <ProcessDepUploads /> },
      { path: 'updatenew/:id', element: <UpdateSelfReg /> }
    ]
  },
  {
    path: '/public',
    // element: <AppLayout />,
    element: !isAuthenticated ? <AppLayout /> : <Navigate to="/dashboard/app" />,
    children: [{ path: 'home', element: <Home /> }]
  },
  {
    path: '/',
    element: <LogoOnlyLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: 'selfregister', element: <SelfRegister /> },
      { path: 'signatureself', element: <SelfRegSign /> },
      { path: 'signature', element: <SelfRegSignature /> },
      { path: 'redirect', element: <SelfRegRedirect /> },
      { path: 'managementdash', element: <ManagementDash /> },
      { path: 'privacy', element: <Privacy /> },
      { path: 'terms', element: <Terms /> },
      { path: 'removedata', element: <RemoveData /> },
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '*', element: <Navigate to="/404" /> },
      { path: 'underdev', element: <UnderDev /> }
    ]
  },
  {
    path: '/reportsnew',
    element: <DashboardLayout />,
    children: [
      { path: 'claimsSummary', element: <ProviderClaimsSummary /> },
      { path: 'providerSummary', element: <ProviderSummary /> },
      { path: 'claimsProvider', element: <ProviderClaims /> },
      { path: 'selfpmtsummary', element: <SelfPmtClaimsSummary /> },
      { path: 'claimsDepartment', element: <ClaimsByDeptSum /> },
      { path: 'claimsDeptDetail', element: <ClaimsByDeptDetail /> },
      { path: 'claimsbydiagnosis', element: <ClaimsByDiagnosis /> },
      { path: 'membersbygroup', element: <MembersByGroup /> },
      { path: 'membersbygroupdetail', element: <MembersByGroupDetail /> },
      { path: 'claimsstatistics', element: <ClaimsStatistics /> },
      { path: 'nonawards', element: <ProviderNonAwards /> },
      { path: 'viewstatement/:id', element: <PrintStatement /> },
      { path: 'receiptlist', element: <ReceiptList /> }
      // { path: 'claimsDiagnosis', element: <ClaimsDiagnosis /> },
      // { path: 'claimsNonAwarded', element: <ClaimsNonAwarded /> },
      // { path: 'batchSummary', element: <BatchSummary /> }
    ]
  },
  {
    path: '/membershipreports',
    element: <DashboardLayout />,
    children: [
      { path: 'byprovince', element: <MembershipProvince /> },
      { path: 'bydistrict', element: <MembershipDistrict /> },
      { path: 'bybreakdown', element: <DistrictBreakdown /> },
      { path: 'byage', element: <MembershipAge /> },
      { path: 'bysummary', element: <MembershipsSummary /> },
      { path: 'activewithoutkids', element: <ActiveWithoutKids /> },
      { path: 'activewithoutspouse', element: <ActiveWithoutSpouse /> },
      { path: 'byprovincefile', element: <ProvinceFiles /> },
      { path: 'byretire', element: <MembershipRetire /> },
      { path: 'provOnsOffs', element: <OnsOffsCharts /> }
    ]
  },
  {
    path: '/reports',
    element: <DashboardLayout />,
    children: [
      { path: 'claimsSummary', element: <ClaimsSummaryProvider /> },
      { path: 'claimsProvider', element: <ClaimsProvider /> },
      { path: 'claimsDepartment', element: <ClaimsDepartment /> },
      { path: 'claimsDeptDetail', element: <ClaimsDeptDetail /> },
      { path: 'claimsDiagnosis', element: <ClaimsDiagnosis /> },
      { path: 'claimsNonAwarded', element: <ClaimsNonAwarded /> },
      { path: 'actuarialReport', element: <ActuarialReport /> },
      { path: 'batchSummary', element: <BatchSummary /> },
      { path: 'fullmembership', element: <FullMembership /> },
      { path: 'membershipagegroup', element: <MembershipAgeGroup /> },
      { path: 'membershipagestats', element: <MembershipAgeStats /> },
      { path: 'membershipchanges', element: <MembershipChanges /> },
      { path: 'membershipstats', element: <MembershipStats /> },
      { path: 'fileReport', element: <FileReports /> },
      { path: 'remittanceprovider', element: <RemittanceProvider /> },
      { path: 'remittance', element: <Remittance /> },
      { path: 'remittanceself', element: <RemittanceSelf /> },
      { path: 'report/:id', element: <DateRangeReport /> }
    ]
  },
  {
    path: '/claims',
    element: <DashboardLayout />,
    children: [
      { path: 'createbatches', element: <CreateBatches /> },
      { path: 'batchmultipledr', element: <BatchMultipleDr /> },
      { path: 'claimsProvider', element: <ClaimsProvider /> },
      { path: 'selectBatch', element: <SelectBatch /> },
      { path: 'claimsSelect/:id', element: <ClaimsSelect /> },
      { path: 'claim/:id', element: <Claims /> },
      { path: 'claimsself/:id', element: <ClaimsSelf /> },
      { path: 'benefitsLookup', element: <BenefitsLookUp /> },
      { path: 'processClaim/:id', element: <ClaimsProcess /> },
      { path: 'claimsSearch', element: <ClaimsSearch /> },
      { path: 'claimsImport', element: <ClaimsImportList /> },
      { path: 'claimsImportFile/:id', element: <ClaimsImport /> },
      { path: 'claimsImportnew', element: <ClaimsImportNew /> },
      { path: 'claimsonline', element: <ClaimsOnline /> },
      { path: 'onlineClaims/:id', element: <OnlineProcessVet /> },
      { path: 'disbursementfiles', element: <DisbursementFile /> }
    ]
  },
  {
    path: '/accounts',
    element: <DashboardLayout />,
    children: [
      { path: 'journals/:id', element: <Journal /> },
      { path: 'journalself/:id', element: <JournalSelf /> },
      { path: 'vouchers', element: <SelectVouchers /> },
      { path: 'selfvouchers', element: <SelectSelfVouchers /> },
      { path: 'provideraccount', element: <ProviderAccount /> },
      { path: 'claimsProvider', element: <ClaimsProvider /> },
      { path: 'adjustments', element: <Adjustment /> },
      { path: 'providerbalances', element: <ProviderBalances /> },
      { path: 'memberbalances', element: <MemberBalances /> },
      { path: 'extrapayment', element: <ExtraPayment /> },
      { path: 'extrareceipt', element: <ExtraReceipt /> },
      { path: 'paybill', element: <PayBill /> },
      { path: 'selfpmtsbalances', element: <SelfPmtsBalances /> },
      { path: 'selectbill', element: <SelectBill /> },
      { path: 'paymentsummary', element: <BillsList /> },
      { path: 'extractssb', element: <ExtractSsb /> },
      { path: 'ssbhistory', element: <SsbHistory /> },
      { path: 'receiptfile', element: <ReceiptFile /> },
      { path: 'bill/:id', element: <Bill /> },
      { path: 'ssbprocess/:id', element: <SsbProcess /> },
      { path: 'selectssb', element: <SelectSsb /> }
    ]
  },
  {
    path: '/ssb',
    element: <DashboardLayout />,
    children: [
      { path: 'processfile/:id', element: <ProcessFile /> },
      { path: 'receiptfile', element: <ReceiptFile /> },
      { path: 'changefile', element: <SsbChangeFile /> },
      { path: 'newchangefile', element: <NewChangeFile /> },
      { path: 'processchangefile/:id', element: <ProcessChangeFile /> },
      { path: 'claimsProvider', element: <ClaimsProvider /> },
      { path: 'selectBatch', element: <SelectBatch /> },
      { path: 'claimsSelect/:id', element: <ClaimsSelect /> },
      { path: 'claim/:id', element: <Claims /> },
      { path: 'claimsself/:id', element: <ClaimsSelf /> },
      { path: 'filesinfo', element: <FilesInfoLookUp /> },
      { path: 'defaults', element: <Defaults /> },
      { path: 'pendingsubmission', element: <PendingSubmission /> },
      { path: 'registerinternal', element: <RegisterInternal /> },
      { path: 'bulkbilldetails', element: <BulkBillDetails /> },
      { path: 'provincessb', element: <ProvinceSsbUpload /> },
      { path: 'receipthist', element: <ReceiptFileHist /> },
      { path: 'ssbhistfiles', element: <SsbHistFiles /> },
      { path: 'processhistfile/:id', element: <ProcessHistFile /> },
      { path: 'claimsSearch', element: <ClaimsSearch /> },
      { path: 'onoffdash', element: <OnOffDash /> }
    ]
  },
  {
    path: '/tariff',
    element: <DashboardLayout />,
    children: [{ path: 'updateTariffs', element: <UpdateTariffs /> }]
  },
  {
    path: '/settings',
    element: <DashboardLayout />,
    children: [
      { path: 'configmodules', element: <ConfigModules /> },
      { path: 'configapis', element: <ConfigApis /> },
      { path: 'configscheduler', element: <ConfigScheduler /> },
      { path: 'configtemplates', element: <ConfigTemplates /> },
      { path: 'confignotifications', element: <ConfigNotifications /> },
      { path: 'configusers', element: <ConfigUsers /> },
      { path: 'errorcodes', element: <ErrorCodes /> },
      { path: 'claimstatuses', element: <ClaimStatuses /> },
      { path: 'banklist', element: <BankList /> },
      { path: 'configenterprise', element: <ConfigEnterprise /> },
      { path: 'cyclemgmt', element: <CycleMgmt /> },
      { path: 'limitsmgmt', element: <LimitsMgmt /> },
      { path: 'providers', element: <Providers /> },
      { path: 'tariffsSearch', element: <SearchTariff /> },
      { path: 'templates', element: <TemplateList /> },
      { path: 'scheduler', element: <TaskScheduler /> },
      { path: 'ssbcodes', element: <SsbCodes /> },
      { path: 'configusers', element: <ConfigUsers /> },
      { path: 'createUser', element: <CreateUser /> },
      { path: 'editUser/:refId', element: <EditUser /> },
      { path: 'managetemplates', element: <ManageTemplates /> },
      // { path: 'downloadfiles', element: <DownloadFireFiles /> },
      { path: 'edittemplate', element: <TemplateSetup /> }
    ]
  },

  { path: '*', element: <Navigate to="/404" replace /> }
];

export default Router;
